import React from 'react'
import { Table } from 'react-bootstrap'
import { formatTimeString } from '../../utils/formatters'
import { CollapsableContainer } from '../common/collapsable_container'
import { DivContentBox } from '../common/styled'

const TxAuditLog = ({ data }) => (
  <CollapsableContainer count={data.length} title={'Audit Log'}>
    <DivContentBox>
      {data && data.length ? (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>ID</th>
              <th>Actor</th>
              <th>Changes</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {data.reverse().map((entry) => {
              const changes = JSON.parse(entry.changes)
              return (
                <tr key={entry.id}>
                  <td>{entry.id}</td>
                  <td>{entry.actor}</td>
                  <td>
                    {Object.keys(changes).map((key, i) => {
                      const from =
                        changes[key][0] === '' ? (
                          <span>
                            <i className='fa fa-angle-double-left' />
                            <i className='fa fa-angle-double-right' />
                          </span>
                        ) : (
                          changes[key][0]
                        )
                      const to =
                        changes[key][1] === '' ? (
                          <span>
                            <i className='fa fa-angle-double-left' />
                            <i className='fa fa-angle-double-right' />
                          </span>
                        ) : (
                          changes[key][1]
                        )
                      return (
                        <div key={`${key}${entry.id}`}>
                          {`${key}: `}
                          {` ${from} `}
                          <i className='fa fa-long-arrow-right' />
                          {` ${to}`}
                        </div>
                      )
                    })}
                  </td>
                  <td className='td-nowrap'>{formatTimeString(entry.timestamp)}</td>
                </tr>
              )
            })}
          </tbody>
        </Table>
      ) : (
        <span>{'N/A'}</span>
      )}
    </DivContentBox>
  </CollapsableContainer>
)

export default TxAuditLog
